import { FC } from "react";
import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { Theme } from "theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    maxHeaderBoxGridWidth: {
      maxWidth: "250px",
      [theme.breakpoints.down(400)]: {
        maxWidth: "130px",
      },
    },
    headerBox: {
      color: theme.custom.palette.softWhite.main,
      backgroundColor: theme.custom.palette.purple.main,
      display: "flex",
      textAlign: "center",
      flexDirection: "column",
      justifyContent: "center",
      borderRadius: theme.shape.borderRadius,
      padding: `${theme.spacing(5)}px ${theme.spacing(3)}px`,
      height: "200px",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        height: "160px",
      },
      [theme.breakpoints.only("xs")]: {
        maxHeight: "120px",
      },
    },
    headerBoxValues: {
      fontWeight: 800,
      fontSize: "3.2rem",
      display: "block",
      [theme.breakpoints.down("md")]: {
        fontSize: "2rem",
      },
      [theme.breakpoints.only("xs")]: {
        fontSize: "1.5rem",
      },
    },
    headerBoxValuesCaption: {
      fontWeight: 600,
      fontSize: "0.8rem",
      textTransform: "uppercase",
      letterSpacing: "1.4px",
      paddingTop: theme.spacing(1),
      [theme.breakpoints.only("xs")]: {
        fontSize: "0.6rem",
        letterSpacing: "1.2px",
      },
    },
  }),
);

export interface HeaderBoxProps {
  value: string;
  title?: string;
}

const HeaderBox: FC<HeaderBoxProps> = ({ value, title }) => {
  const classes = useStyles();

  return (
    <Grid item xs={6} className={classes.maxHeaderBoxGridWidth}>
      <Box className={classes.headerBox}>
        <Typography className={classes.headerBoxValues} variant="h2">
          {value}
        </Typography>
        <Typography
          className={classes.headerBoxValuesCaption}
          variant="subtitle2"
        >
          {title}
        </Typography>
      </Box>
    </Grid>
  );
};

export default HeaderBox;
